import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { IoIosCheckmarkCircle } from 'react-icons/io';

import ErrorMessages from './errorMessages';
import {changePasswordAction} from './../actions/resetPasswordAction';

import 'react-toastify/dist/ReactToastify.css';

class FormCorreoRecuperacionToken extends Component {

  constructor(props){
    super(props);

    this.state = {
      password: '',
      passwordConfirm: '',
      errors: {},
      errorLogin: '',
      isSubmitting: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.isSubmitting = this.isSubmitting.bind(this);
    this.onCloseToast = this.onCloseToast.bind(this);
  }

  handleSubmit(event){
    event.preventDefault();

    let values = {
      password: this.state.password,
      passwordConfirm: this.state.passwordConfirm
    };
    this.validate(event, values);
  }

  validate(event, values) {
    let errors = {};

    if (!values.password || values.password==='' ) {
      errors.password = 'Por favor, introduce tu contraseña';
    } else if (values.password.length < 6) {
      errors.password = 'Por favor, introduce por lo menos 6 caracteres.';
    } else  if (!values.passwordConfirm || values.passwordConfirm==='' ) {
      errors.passwordConfirm = 'Por favor, confirma tu contraseña';
    } else if (values.password !== values.passwordConfirm ) {
      errors.sinCoincidencia = 'Las contraseñas no coinciden.';
    }

    this.setState({ errors });
    this.isSubmitting(event, errors, values);
  }

  isSubmitting(event, errors, values){
    event.preventDefault();

    if (Object.keys(errors).length === 0 ) {
      const token = this.props.match.params.token;

      const valuesSend = {
        token: token,
        password: values.password
      };

      this.setState({
        isSubmitting: true
      });

      return changePasswordAction(valuesSend).then(r => {
        if(r.ok){
          this.setState({
            errorLogin: ''
          });

          toast.warn(<div><IoIosCheckmarkCircle className='icon-toast' />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' Tu contraseña se ha actualizado correctamente.'}</div>, {
            position: toast.POSITION.TOP_RIGHT,
            onClose: this.onCloseToast,
            autoClose: 5000,
          });

        } else if(!r.ok){
          this.setState({
            errorLogin: 'La liga no es correcta o ha caducado, por favor realiza el proceso nuevamente'
          });
        }
      });
    }

  }

  onCloseToast() {
    this.props.history.push('/login/admin');
  }

  render() {

    return (
      <div className="content-form-login">
        <form id="formCorreoRecuperacion"  method="post" onSubmit={this.handleSubmit}>
          <div className="row">
            <ErrorMessages errors={this.state.errors} errorLogin={this.state.errorLogin}></ErrorMessages>
            <div className="col-md-12">
              <div className="form-froup">
                <div className="input-group input-group-login-SA m-b-7-login">
                  <input type="password" id="password" name="password" placeholder="contraseña" value={this.state.password}
                    onChange={event => this.setState({ password: event.target.value })}
                    className={this.state.errors.password && ('input-errorLine')}/>
                  <label>Por favor, ingresa tu nueva contraseña</label>
                  <div className="input-group-append-login">
                    <img src="/assets/login/Contrasena_on-03.svg" className="iconUser-login" alt="iconPass"></img>
                  </div>
                  <span className="highlight"></span>
                  <span className="bar"></span>
                </div>
                <div className="input-group input-group-login-SA m-b-7-login">
                  <input type="password" id="passwordConfirm" name="passwordConfirm" placeholder="confirmar contraseña" value={this.state.passwordConfirm}
                    onChange={event => this.setState({ passwordConfirm: event.target.value })}
                    className={this.state.errors.passwordConfirm && ('input-errorLine')}/>
                  <label>Por favor, confirma tu nueva contraseña</label>
                  <div className="input-group-append-login">
                    <img src="/assets/login/Contrasena_on-03.svg" className="iconUser-login" alt="iconPass"></img>
                  </div>
                  <span className="highlight"></span>
                  <span className="bar"></span>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="row m-t-10-login justify-content-end">
          <div className="col-md-7 col-12 m-b-7-login">
            {(!this.state.isSubmitting) ? (
              <button type="submit" form="formCorreoRecuperacion" className="btn-primaryReward" >{'Cambiar >'}</button>
            ) : (
              <div></div>
            )}

          </div>
        </div>
        <ToastContainer/>
      </div>
    );
  }
}

FormCorreoRecuperacionToken.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    })
  }),
  history:PropTypes.object,
};

export default withRouter(FormCorreoRecuperacionToken);
